module.exports ={
    templates: {
        all: '全部',
        add:'追加',
        loadTip: {
            fail: 'テンプレートデータを読み込めませんでした',
            permission: 'テンプレートデータを表示する権限がありません'
        },
        addTip: {
            success: 'テンプレートが正常に追加されました',
            exist: 'テンプレート名はすでに存在します',
            fail:'テンプレートを追加できませんでした',
            permission: 'テンプレートを追加する権限がありません'
        },
        delTip:{
            msg:'{demoName}を削除してもよろしいですか？削除すると、現在のテンプレートのラベルにバインドされているテンプレートが削除されます',
            success: 'テンプレートが正常に削除されました',
            exist: '削除されたテンプレートは存在しないか、削除されています',
            fail:'テンプレートを削除できませんでした',
            permission: 'テンプレートを削除する権限がありません'
        },
        copyTip: {
            success: 'テンプレートのコピーに成功しました',
            exist: 'テンプレート名は既に存在しました',
            fail:'テンプレートのコピーに失敗しました',
            permission: 'テンプレートをコピーする権限がありません。'
        },
        find:'テンプレート名を検索',
        findSize: 'サイズを探す',
        findColor: '色を検索',
        addTitle: '新しいテンプレート',
        delTitle:'テンプレートを削除',
        copyTitle: 'テンプレートをコピーする',
        demoName: 'テンプレート名',
        demoNameMsg: 'テンプレート名を入力してください',
        demoNameFail: '失敗しました。再入力してください',
        screenSize:'画面サイズ',
        sizeSelectMsg:'全サイズ',
        // screenOpt:['1.54"','2.13"','2.9"','4.2"'],
        screenOpt:[1.54, 2.13, 2.66, 2.9, 4.2, 5.83, 7.5, 11.6],
        // screenOpt:[1.54,2.13,2.9,4.2,5.83,7.5],
        // screenOpt:[
        //     {
        //         label: 'サイズを選択してください',
        //         value: 0
        //     },{
        //         label: 1.54,
        //         value: 1.54
        //     },{
        //         label: 2.13,
        //         value: 2.13
        //     },{
        //         label: 2.9,
        //         value: 2.9
        //     },{
        //         label: 4.2,
        //         value: 4.2
        //     }
        // ],
        // screenOptDetail:['1.54" (152*152)','2.13" (212*104)','2.9" (296*128)','4.2" (400*300)'],
        demoTypes: [
            {
                label: '全部',
                value: 0
            },{
                label: 'ストアテンプレート',
                value: 2
            },{
                label: 'システムテンプレート',
                value: 1
            }
        ],
        screenOptDetail:[
            {
                inch: 1.54,
                width: 152,
                height: 152,
                id: 1
            },
            {
                inch: 1.54,
                width: 200,
                height: 200,
                id: 2
            },
            // {
            //     inch: 2.13,
            //     width: 212,
            //     height: 104,
            //     id: 3
            // },
            {
                inch: 2.13,
                width: 250,
                height: 122,
                id: 3
            },
            {
                inch: 2.66,
                width: 296,
                height: 152,
                id: 4
            },
            {
                inch: 2.9,
                width: 296,
                height: 128,
                id: 5
            },
            {
                inch: 4.2,
                width: 400,
                height: 300,
                id: 6
            },
            {
                inch: 5.83,
                width: 648,
                height: 480,
                id: 7
            },
            {
                inch: 7.5,
                width: 880,
                height: 528,
                id: 8
            },
            {
                inch: 11.6,
                width: 960,
                height: 640,
                id: 10
            }
        ],
        optionalColor: '選べる色',
        // optionalColors: [
        //     {
        //         label: '黑白红',
        //         value: 'red'
        //     },{
        //         label: '黑白黄',
        //         value: 'yellow'
        //     },{
        //         label: '黑白',
        //         value: 'black'
        //     }
        // ],
        optionalColors: {
            default: {
                label: '全色',
                value: ''
            },
            red: {
                label: '黒と白赤',
                value: 'red'
            },
            yellow: {
                label: '黒と白の黄色',
                value: 'yellow'
            },
            black: {
                label: '黒白',
                value: 'black'
            }
        },
        optionalColorMsg: 'オプションの色を選択してください',
        screenOrientation: '画面の向き',
        optionalOrientation: [
            {
                label: '横型',
                value: 0
            }, {
                label: '直立',
                value: 1
            }
        ],
        optionalOrientationMsg: '画面の向きを選択してください',
        cancel: 'キャンセル',
        sure: '確定',
        sampleContent: {
            proNo:'1101',
            name:'Minew電子棚札',
            proAbbr: '電子棚札',
            brand: 'Minew',
            price:'￥68.00',
            origin:'深セン、中国',
            rating:'A',
            piece:'个',
            specification:'2901',
            supplierName:'Minew',
            barcodeText:'6666666666666',
            qrcodeText: 'http://minewtech.com',
            barcode:'6666666666666',
            qrcode:"http://minewtech.com"
        },
        samplePrefix: {
            proNo:'番号：',
            name:'お名前：',
            proAbbr: '略称：',
            brand: 'ブランド：',
            price:'',
            origin:'産地：',
            rating:'ランク：',
            piece:'単位：',
            specification:'規格：',
            supplierName:'ベンダー：',
            barcodeText:'',
            qrcodeText: ''
        },
        noData: 'データなし',
        submiting: '提出中...',
        text: 'テキスト'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/templates.js